import { react, useState, useRef } from 'react';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import styles from './CustomerLogin.module.css'; // Import css modules stylesheet as styles
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import ReCAPTCHA from "react-google-recaptcha";
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import TokenService from '../../services/TokenService';
import Snackbar from '@mui/material/Snackbar';
import { useSnackbar } from 'notistack';
import LoadingIndicator from '../LoadingIndicator'

export default function RecyclerLogin(props) {
    const [emailAddress, setEmailAddress] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isComplete, setIsComplete] = useState(false);
    const captchaRef = useRef(null);
    const [formValidation, setFormValidation] = useState({
        isValid: false,
        errors: []
    });
    const [snackbar, setSnackbar] = useState({
        message: '',
        severity: 'info'
    });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    function onAccept() {

        let isValid = true;
        let errors = [];

        if (emailAddress.trim() === '') {
            errors["EmailAddress"] = "Missing your Email";
            isValid = false;
        }
        else {
            if (!isValidEmail(emailAddress.trim())) {
                isValid = false;
                errors["EmailAddress"] = "Not a valid email.";

            }
            else {
                if (emailAddress.trim().toLowerCase().indexOf('@gmail.') > -1 &&
                    emailAddress.trim().toLowerCase().indexOf('@gmail.com') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @gmail.com?";
                }
                else if (emailAddress.trim().toLowerCase().indexOf('@yahoo.') > -1 &&
                    emailAddress.trim().toLowerCase().indexOf('@yahoo.com') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @yahoo.com?";
                }
                else if (emailAddress.trim().toLowerCase().indexOf('@hotmail.') > -1 &&
                    emailAddress.trim().toLowerCase().indexOf('@hotmail.com') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @hotmail.com?";
                }
                else if (emailAddress.trim().toLowerCase().indexOf('@aol.') > -1 &&
                    emailAddress.trim().toLowerCase().indexOf('@aol.com') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @aol.com?";
                }
                else if (emailAddress.trim().toLowerCase().indexOf('@comcast.') > -1 &&
                    emailAddress.trim().toLowerCase().indexOf('@comcast.net') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @comcast.net?";
                }
                else if (emailAddress.trim().toLowerCase().indexOf('@sbcglobal.') > -1 &&
                    emailAddress.trim().toLowerCase().indexOf('@sbcglobal.net') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @sbcglobal.net?";
                }
                else if (emailAddress.trim().toLowerCase().indexOf('@icloud.') > -1 &&
                    emailAddress.trim().toLowerCase().indexOf('@icloud.com') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @icloud.com?";
                }
                else if (emailAddress.trim().toLowerCase().indexOf('@outlook.') > -1 &&
                    emailAddress.trim().toLowerCase().indexOf('@outlook.com') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @outlook.com?";
                }
                else if (emailAddress.trim().toLowerCase().indexOf('@msn.') > -1 &&
                    emailAddress.trim().toLowerCase().indexOf('@msn.com') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @msn.com?";
                }

            }
        }

        const token = captchaRef.current.getValue();
        if (token.trim() == '') {
            errors["token"] = "Check here if you're human";
            isValid = false;
        }

        setFormValidation({
            isValid: isValid,
            errors: errors
        });

        if (isValid) {
            setIsLoading(true);
            //TokenService
            let postData = {
                emailAddress: emailAddress,
                token: token
            }

            TokenService.post(postData, 'PasswordResetRequest', '')
                .then((response) => {
                    if (response !== null) {
                        setIsLoading(false);
                        response = response[Object.keys(response)[0]];
                        if (response.Result === "SUCCESS") {
                            //let jsonData = JSON.parse(response.JsonData);

                            setIsComplete(true);
                        }
                        else if (response.Result === "FAIL") {
                            enqueueSnackbar(response.Message, {
                                variant: 'error',
                            });
                        }
                    }
                })
                .catch((response) => {
                    if (response !== null) {
                        enqueueSnackbar('Oops, something went wrong', {
                            variant: 'error',
                        });

                    }
                });

        }
        

        
    }

    function isValidEmail(email) {
        return /\S+@\S+\.\S+/.test(email);
    }

    

    let loadingPanel = null;
    let completePanel = null;
    let formPanel = null;

    if (isLoading) {
        loadingPanel = <LoadingIndicator Message='Sending Password Reset request' /> 
    }

    if (isComplete) {
        completePanel =
            <div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <MailOutlineIcon sx={{ color: 'var(--sipzee-green)', fontSize: 50 }} />
                </div>
                <div style={{ textAlign: 'center', marginTop: '10px', fontStyle: 'italic' }}>
                    {props.viewType == 'password' ?
                        'If your email matches, we sent you a Password Reset link. '
                        :
                        'If your email matches the one you used to create a pickup, we will send you a link to create your password.'
                     }
                </div>
                <div style={{ textAlign: 'center', marginTop: '10px', fontStyle: 'italic' }}>
                    If you do not receive an email check your spam folder, try again, or contact us
                </div>
            </div>
    }

    if (!isLoading && !isComplete) {
        formPanel = <div>
            <div className={styles.ContactSectionHeader}>
                {props.viewType == 'password' ? 'Forgot your password?'
                    :
                    'Register for an Account'
                }
            </div>
            {props.viewType == 'password' ? null :

                <div className={styles.ContactSectionBody} style={{textAlign:'left'}}>
                    <div style={{fontStyle:'italic', fontSize:'10pt', color:'var(--sipzee-red)'} }>
                        An account is not required to use Sipzee as a customer.
                    </div>
                    <div style={{marginTop:'10px'} }>
                        With an account, you can:
                        <ul>
                            <li>More easily create another pickup</li>
                            <li>View your history</li>
                        </ul>
                    </div>
                </div>
                }
            <div className={styles.ContactSectionBody}>
                <TextField className={styles.ContactSectionText} error={formValidation.errors['Email'] !== undefined} label="Email" onChange={(e) => setEmailAddress(e.target.value)} value={emailAddress} variant="outlined" />
                <div className={styles.FormFieldErrorDescription} style={{ textAlign: 'left' }}> {formValidation.errors['EmailAddress'] !== undefined ? formValidation.errors['EmailAddress'] : ''}</div>
            </div>



            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
                <ReCAPTCHA
                    sitekey={process.env.REACT_APP_SITE_KEY}
                    ref={captchaRef}
                />
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
                <div className='FormFieldErrorDescription'> {formValidation.errors['token'] !== undefined ? formValidation.errors['token'] : ''}</div>
            </div>
        </div>
    }

    return (
        <div>
            <Dialog
                open={true}
                maxWidth="330px"

                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent style={{ width: '330px' }}>

                    {loadingPanel}
                    {completePanel}
                    {formPanel}


                </DialogContent>
                <DialogActions style={{ justifyContent: 'flex-start' }}>
                    <Button variant='outlined' onClick={props.onClose} disabled={isLoading }>
                        {(isComplete ? 'Close' : 'Cancel')}
                    </Button>
                    {
                        completePanel ?
                            null :
                            <Button variant='contained' onClick={onAccept} style={{ marginLeft: 'auto', backgroundColor: 'var(--sipzee-green)' }} disabled={isLoading}>
                                {props.viewType == 'password' ? 'Reset' : 'Register'}
                            </Button>
                    }
                   
                </DialogActions>
            </Dialog>
        </div>
        )
    
}
